export default "__VITE_ASSET__BTDTuqoF__"